import { useEffect } from "react";
import { useState } from "react";

const useWhiteLabelFooter = (accountID, whiteLabelType) => {
    const [footerPrefix, setFooterPrefix] = useState(undefined)

    useEffect(() => {
        if (whiteLabelType) {
            if (whiteLabelType.toLowerCase() === "pvblicone") {
                setFooterPrefix("2024 PVBLIC Foundation")
            } else {
                setFooterPrefix(" ")
            }
        } else {
            setFooterPrefix("© 2024 Sqreem Technologies Pte. Ltd.")
        }
    }, [accountID, whiteLabelType])

    return footerPrefix;
}

export default useWhiteLabelFooter